import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import { Divider } from 'primereact/divider';
import { useNavigate } from 'react-router-dom';
import styles from './AmendBillingAgreementDialog.styles.scss';
import cn from 'classnames';
import { AGREEMENT_TYPE } from '../../config/constants';

const AmendBillingAgreementDialog = ({
  isOpen,
  setIsOpen,
  onSubmit,
  values,
  agreementType,
}) => {
  const navigate = useNavigate();

  const { t, i18n } = useTranslation();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Dialog
      className={cn(
        'rounded-4 overflow-hidden',
        styles.addBillingAgreementDialog,
      )}
      visible={isOpen}
      footer={
        <>
          <Divider className="mb-4" />
          {isSubmitted ? (
            <Button
              onClick={() => {
                setIsOpen(false);
                navigate(
                  `/${i18n.language}/additional-functionalities/special-billing`,
                );
              }}
              type="button"
              className="px-5 w-100"
              size="medium"
              label={t('common.home')}
            />
          ) : (
            <div className="d-flex">
              <Button
                onClick={() => {
                  setIsOpen(false);
                }}
                type="button"
                className="px-5 flex-grow-1"
                size="medium"
                outlined
                label={t('common.cancel')}
              />
              <Button
                onClick={() => {
                  setIsLoading(true);
                  onSubmit()
                    .then(() => {
                      setIsSubmitted(true);
                    })
                    .finally(() => {
                      setIsLoading(false);
                    });
                }}
                loading={isLoading}
                type="button"
                className="px-5 flex-grow-1"
                size="medium"
                label={t('common.confirm')}
              />
            </div>
          )}
        </>
      }
    >
      {!isSubmitted && (
        <div className={styles.submissionMessage}>
          <span>
            <i className="pi pi-file-edit" />
          </span>
          <h3>
            {agreementType === AGREEMENT_TYPE.SELF
              ? t('special_billing.amend_confirm_title')
              : t('special_billing.amend_confirm_title_third_party')}
          </h3>
          <p>{t('special_billing.amend_confirm_desc')}</p>
        </div>
      )}
      {isSubmitted && (
        <div className={styles.submissionMessage}>
          <span>
            <i className="pi pi-file-edit" />
          </span>
          <h3>
            {t('special_billing.request_number_info', {
              number: values?.referenceNumber,
            })}
          </h3>
          <p>
            {agreementType === AGREEMENT_TYPE.SELF
              ? t(
                  'special_billing.thank-you-for-submitting-the-request-for-self-billing-agreement',
                )
              : t(
                  'special_billing.thank-you-for-submitting-the-request-for-third-party-billing-agreement',
                )}
          </p>
          <p>{t('special_billing.amend-self-billing-dialog-desc')}</p>
        </div>
      )}
    </Dialog>
  );
};

export default React.memo(AmendBillingAgreementDialog);
